import { render } from "./FunctionalMenus.vue?vue&type=template&id=32a9d11f"
import script from "./FunctionalMenus.vue?vue&type=script&lang=js"
export * from "./FunctionalMenus.vue?vue&type=script&lang=js"

import "./FunctionalMenus.vue?vue&type=style&index=0&id=32a9d11f&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/build_logistics-fe-ntp-hz_b7ac09e112f74cf29c780ec3b0fe9d8e/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__